import React from 'react';
import PropTypes from 'prop-types';
import {I18n, Translate} from 'react-redux-i18n';
import {useLocation} from 'react-router-dom';

import {Paginator} from 'front-onceforall-core';

import {getSearchValues} from '../../../utils/search';
import {MAX_QUERY_LENGTH} from '../../../utils/constant';
import ListSearchBar from '../../listSearchBar';
import {useCustomStore} from '../GlobalSubcontractorsStore';
import ListItem from './listItem';

function ListView(props) {
  const {state: customStore} = useCustomStore();
  const location = useLocation();
  const {queryString} = getSearchValues(location.search);
  const [isTyping, setIsTyping] = React.useState(false);

  return (
    <>
      <ListSearchBar
        onSearch={props.onSearch}
        isTyping={typing => setIsTyping(typing)}
        defaultValue={queryString || ''}
        label={<Translate value="organisation.search.inputLabel"/>}
        placeholder={I18n.t('organisation.search.placeholder')}
        maxQueryLength={MAX_QUERY_LENGTH}
      />
      {customStore.error ?
        <Translate value="error.generic"/> :
        <>
          {(customStore.loading || isTyping) && <div className="loading-overlay"/>}
          {customStore.subcontractors.length === 0 ?
            <div className="table-without-result">
              <Translate value="subcontractor.search.notFound"/>
            </div> :
            <table className="clickable-row">
              <thead>
                <tr>
                  <td><Translate value="organisation.fullName"/></td>
                  <td><Translate value="organisation.registrationNumber"/></td>
                  <td><Translate value="address.postCode"/></td>
                  <td><Translate value="address.city"/></td>
                  <td><Translate value="dossier.state.title"/></td>
                  <td/>
                </tr>
              </thead>
              <tbody>
                {customStore.subcontractors.map((organisation, index) => (
                  <ListItem
                    key={index}
                    organisation={organisation}
                  />
                ))}
              </tbody>
            </table>
          }
          <Paginator
            totalItems={customStore.totalCount}
            pageSize={customStore.pageSize}
            currentPage={props.pageNumber}
            onChangePage={props.onPageChange}
          />
        </>
      }
    </>
  );
}

ListView.propTypes = {
  onPageChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  pageNumber: PropTypes.number.isRequired
};

export default ListView;
